// extracted by mini-css-extract-plugin
export default {"container":"privacidade_container__XGV5D","header":"privacidade_header__WHiAU","partnerCard":"privacidade_partnerCard__MaPwU","footer":"privacidade_footer__vSDMA"};